const CLIENT_ADMIN_JOB_ID = "J02347"
const CLIENT_ADMIN_TASK_TYPE_UUID ="9c483d77-e60b-4ab4-8a36-cac41eb36ba9"

export function updateJobState(vue, salesJobId, newStage) {
  let jobStatus = `Sales-${vue.$capitalize(newStage)}`
  if (['won', 'lost', 'archive'].includes(newStage)) {
    jobStatus = 'Completed'
  }
  return vue.$WfmApi.put("job.api/state", {
    Job: {ID: salesJobId, State: jobStatus}
  })
}

export async function checkClientAdminTask(vue, clientName) {
  const taskName = `Client Admin Unbillable - ${clientName}`
  const response = await vue.$WfmApi.get("job.api/get/" + CLIENT_ADMIN_JOB_ID, {voidCache: true})
  if (!response || !response.Job) return

  const tasks = response.Job.Tasks ? vue.$ensureArray(response.Job.Tasks.Task) : []

  if (tasks.some(t => t.Name === taskName)) return

  const newTaskResponse = await vue.$WfmApi.post("job.api/task", {
    Task: {
      Job: CLIENT_ADMIN_JOB_ID,
      Description: "something",
      Label: clientName,
      EstimatedMinutes:0,
      TaskUUID: CLIENT_ADMIN_TASK_TYPE_UUID,
    }
  })

  if (newTaskResponse) {
    const staffRes = await vue.$BwfApi.get("staff")
    const allStaffUUIDs = staffRes.map(s => s.wfm_userid)
    const currentlyAssigned = response.Job.Assigned && response.Job.Assigned.Staff
      ? vue.$ensureArray(response.Job.Assigned.Staff).map(s => s.UUID)
      : []
    const toAdd = allStaffUUIDs.filter(uuid => !currentlyAssigned.includes(uuid))
    for (const uuid of toAdd) {
      vue.$WfmApi.put("job.api/assign", {Job: {ID: CLIENT_ADMIN_JOB_ID, add: {"@uuid": uuid}}})
    }
  }
}
